import * as React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Dashboard from '@mui/icons-material/Dashboard';
import WorkIcon from '@mui/icons-material/Work';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import StoreIcon from '@mui/icons-material/Store';
import styled from 'styled-components';
import CategoryIcon from '@mui/icons-material/Category';

const CardWrapper =  styled.div`
    
    display: none;

    @media screen and (max-width:720px){
        display: block;
        position: fixed;
        bottom: 0;
        width: 100%;
        
    }


`

export default function MobileMenu() {
  const navigate = useNavigate()
  const [value, setValue] = React.useState(0);

  const pathName = window.location.pathname

  const redirectToServiceServicePage = () => {
    window.location.href="/dashboard/products"
  }
  const redirectToDashboardPage = () => {
    navigate("/dashboard")

  }
  const redirectToCategoryPage = () => {
    navigate("/dashboard/categorys")
  }

  useEffect(() => {

    if(pathName == "/dashboard"){
      setValue(2)
    }

    if(pathName == "/dashboard/categorys"){
      setValue(1)
    }

  },[pathName])
  

  return (
      <CardWrapper>
      <BottomNavigation
        showLabelsz
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      >
        <BottomNavigationAction label="Dashboard" onClick={() => redirectToDashboardPage()} icon={<Dashboard />} />
      </BottomNavigation>
      </CardWrapper>
  );
}